export default __webpack_public_path__ + "static/media/gyne.1304e919.svg";